import { UserDetails } from '../../models/userDetailsType';
import { userDetailsActions } from './slice';

export const updateUser = userDetailsActions.updateUser as (
  payload: UserDetails,
) => void;

export const deleteUser = userDetailsActions.deleteUser as (
  payload: Partial<UserDetails>,
) => void;

// actions needed for tests

export const fetchUsersSuccessAction = userDetailsActions.fetchUsersSuccess as (
  payload: UserDetails[],
) => void;

export const fetchUsersErrorAction = userDetailsActions.fetchUsersError as (
  payload: Error,
) => void;
